export default class formConfig {
  // 招标代理委托-详情
  static configList() {
    return [
      {
        title: "项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目编号：",
            value: "constructionNo",
            type: "slot",
            slotName: "constructionNo",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "项目名称：",
            value: "prjName",
            type: "slot",
            slotName: "prjName",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "项目登记单位名称：",
            value: "prjbuildCorpName",
            type: "slot",
            slotName: "prjbuildCorpName",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "项目登记单位社会信用代码：",
            value: "buildCorpNameCode",
            type: "slot",
            slotName: "buildCorpNameCode",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
        ]
      },
      {
        title: "招标信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "招标联系人：",
            value: "tenderLinkMan",
            type: "input",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标联系人电话：",
            value: "tenderLinkPhone",
            type: "input",
            maxlength: 11,
            required: true,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ],
          },
          {
            label: "招标代理联系人：",
            value: "agencyLinkMan",
            type: "input",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标代理电话：",
            value: "agencyLinkPhone",
            type: "input",
            maxlength: 11,
            required: true,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ],
          },
        ]
      },
      {
        title: "代理信息",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "招标代理机构名称：",
            value: "agencyCorpName",
            type: "slot",
            slotName: "agencyCorpName",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标代理机构社会信用代码：",
            value: "agencyCorpCode",
            type: "slot",
            slotName: "agencyCorpCode",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "代理机构法人姓名：",
            value: "agencyCorpLegalPerson",
            type: "slot",
            slotName: "agencyCorpLegalPerson",
            required: true,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "代理机构法人办公电话：",
            value: "agencyCorpLegalPersonTel",
            type: "input",
            width: "50%",
            rule: [
              {
                pattern: /^(?:(0\d{2,3}-)?\d{7,8}|1[3-9]\d{9})$/,
                message: "输入的办公电话不正确！",
              },
            ],
          },
          {
            label: "代理机构技术负责人姓名：",
            value: "agencyCorpTechMan",
            type: "input",
            required: true,
            maxlength: 20,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "代理机构技术负责人办公电话：",
            value: "agencyCorpTechManTel",
            type: "input",
            maxlength: 15,
            width: "50%",
            rule: [
              {
                pattern: /^(?:(0\d{2,3}-)?\d{7,8}|1[3-9]\d{9})$/,
                message: "输入的办公电话不正确！",
              },
            ],
          },
          {
            label: "代理机构注册地址：",
            value: "agencyCorpAddress",
            type: "input",
            maxlength: 150,
            tip: "（最多可填150个汉字）"
          },
          {
            label: "代理项目地址：",
            value: "agencyProjectAddress",
            type: "input",
            maxlength: 150,
            tip: "（最多可填150个汉字）",
          },
          {
            label: "代理内容：",
            value: "agencyMark",
            type: "slot",
            slotName: "agencyMark",
            width: "100%;",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
        ]
      },
      {
        title: "项目负责人信息",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "项目负责人姓名：",
            value: "prjManName",
            type: "input",
            disabled: false,
            width: "50%",
          },
          {
            label: "项目负责人职务：",
            value: "prjManDuty",
            type: "input",
            disabled: false,
            width: "50%",
          },
          {
            label: "项目负责人职称：",
            value: "prjManTitle",
            type: "input",
            disabled: false,
            width: "50%",
          },
          {
            label: "执业资格证书及编号：",
            value: "qualificationCertificateNum",
            type: "input",
            disabled: false,
            width: "50%",
          },
        ]
      },
      {
        title: "其他专职人员",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "list",
            width: "100%",
            class: "formList"
          }
        ]
      },
      {
        title: "监管部门",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "行政监督部门：",
            value: "regulators",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201510311952460006"
            }
          },
          // {
          //   label: "历史核验记录：",
          //   type: "slot",
          //   slotName: "auditOpinion",
          // },
        ]
      },
      {
        title: "代理合同（协议）扫描件",
        name: "8",
        icon: "",
        tipsList: [ { text: "（请上传代理合同等证明文件扫描件！）" } ],
        formConfigList: [
          {
            label: "代理合同（协议）扫描件：",
            type: "slot",
            slotName: "uploadBtn",
          },
        ]
      },
    ];
  }
}
